import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Select from "react-select";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import ProfileInput from "../../../components/ProfilePic";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    GetServiceCaller,

} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import moment from "moment";

const RMGEmployeeView = () => {
    const { id } = useParams();
      const location = useLocation();
  const passedState = location.state;
  console.log("passedState",passedState);
  
    const initialFormData = {
        Title: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        FatherName: "",
        FatherDOB: null,
        Email: "",
        AlternateEMail: "",
        MotherName: "",
        MotherDOB: null,
        IsInActive: "",
        UploadProfileImg: "",
        Gender_020: "",
        DateOfBirth: null,
        MobileNo1: "",
        MobileNo2: "",
        AccountID: "",
        IsRemotly: "",
        IsIntern: "",
        Location: "",
        ContactType_011: "",
        // Correpondence Address
        CorrepondenceAddressType: 823,
        PermanentAddressType: 822,
        CorrespondenceAddress: "",
        CorrespondenceState: "",
        CorrespondenceCountry: "",
        CorrespondenceZipCode: "",
        CorrespondenceAddressPrint: "",
        CorrespondenceCity: "",
        // Permanant Address
        permanentAddressCode: "",
        permanentAddressCountryID: "",
        permanentAddressStateID: "",
        permanentAddressCityID: "",
        permanentAddressZipCode: "",
        permanentPrintAddress: "",
        IsCopyAddress: 0,
        employeeAttachments: [],
        qualification: [
            // {
            //   QualificationType: "",
            //   Qualification: "",
            //   Stream: "",
            //   Institute: "",
            //   University: "",
            //   YearOfPassing: "",
            //   Percentage: "",
            //   LineNo: "1",
            // },
        ],
        identities: [
            {
                IdentityType_063: "",
                NameOnIdentity: "",
                IdentityNo: "",
                IssuingCountry: "",
                IssueDate: null,
                ExpiryDate: null,
                LineNo: "1",
            },
        ],
        files: [],
        filesize: [],
        GSTNo: "",
        VATNo: "",
        CSTNo: "",
        PANNo: "",
        GSTEffectiveDate: null,
        VATEffectiveDate: null,
        CSTEffectiveDate: null,
        STNo: "",
        WorkingStatus: "",
        STEffectiveDate: null,
        GSTRegistrationType_192: "",
        EmployeeCategory_057: "",
        LeaveAccrualType_155: null,
        ReferBy: null,
        ResignationDate: "",
        ConfirmationDate: "",
        RelivingDate: "",
        RelivingType_119: null,
        employeeDetails: [
            {
                LineNo: "1",
                ShiftID: "",
                DepartmentID: "",
                SubDepartmentID: "",
                DesignationID: "",
                FromDate: "",
                ToDate: "",
                ImmediateSuperiorID: "",
                Branch: "",
            },
        ],
        workingarea: [
            { LineNo: "1", EmployeeType_069: "", Company: "", Branch: "" },
        ],
        BloodGroup_062: null,
        MaritalStatus_021: null,
        DateOfAnniversary: "",
        AppointmentDate: null,
        JoiningDate: null,
        PayrollJoiningDate: null,
        OnPayroll: "",
        IsPartTime: "",
        employeebank: [
            {
                AccountNo: "",
                Bank: "",
                IFSCCode: "",
                Branch: "",
                DefaultBank: 0,
                LineNo: "1",
            },
        ],
        DeskPhoneNo: "",
        EmergencyPhoneNo: "",
        EmergencyContactName: "",
        EmergencyContactRelation: "",
        PersonalEmail: "",
        OfficeEmail: "",
        PayTo: "",
        Nationality: null,
        BranchID: "",
    };

    let tableSelectStyle = {
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    const navigate = useNavigate();


    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Employee"));
        fetchEmployeeDetails(id);
    }, []);
    const [formData, setFormData] = useState(initialFormData);
    const [pageLoading, setPageLoading] = useState(true);
    const [submitted, setSubmit] = useState(false);
    let [errors, setErrors] = useState({});
    const [titleOptions, setTitleOption] = useState([]);
    const [accountTypeOption, setAccounTypeOption] = useState([]);
    const [addressTypeOptions, setAddressTypeOptions] = useState([]);
    const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
    const [branchOptions, setBranchOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [conatctTypeOptions, setContactTYpeOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [subDepartmentOptions, setSubDepartmentOptions] = useState([]);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);
    const [genderOptions, setGenderOptions] = useState([]);
    const [gstRegTypeOptions, setGstRegTypeOptions] = useState([]);
    const [identityIssueingOptions, setIdentityIssueingOptions] = useState([]);
    const [identityTypeOptions, setIdentityTypeOptions] = useState([]);
    const [immediateSuperiorOptions, setImmediateSuperiorOptions] = useState([]);
    const [leaveAcuralOptions, setLeaveAcrualTypeOptions] = useState([]);
    const [maritialStatusOptions, setMaritialStatusOptions] = useState([]);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [referedByOptions, setReferedByOptions] = useState([]);
    const [relationTypeOptions, setRelationTypeOptions] = useState([]);
    const [relievingTypeOptions, setRelievingTypeOptions] = useState([]);
    const [shiftsOptions, setShiftsOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [workingStatusOptions, setWorkingStatusOptions] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);
 useEffect(() => {
    fetchIndexData();
      if (formData?.DepartmentID) {
      fetchSubDepartment(formData.DepartmentID);
    }
  }, [formData?.DepartmentID]);
 const fetchIndexData = async () => {
    try {
      let response = await GetServiceCaller(`${API_URL}rujul/employee-data`);
      if (response?.status === 200) {
        setPageLoading(false);
        // title option
        const titlesOpt = response?.data?.data?.titles?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setTitleOption(titlesOpt);

        const accTypeOpt = response?.data?.data?.account_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAccounTypeOption(accTypeOpt);
        const addressTypeOptions = response?.data?.data?.addressType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAddressTypeOptions(addressTypeOptions);
        const bloodGrpOpt = response?.data?.data?.blood_group?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setBloodGroupOptions(bloodGrpOpt);
        const branchOpt = response?.data?.data?.branches?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setBranchOptions(branchOpt);
        const cityOpt = response?.data?.data?.cities?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCityOptions(cityOpt);
        const compOpt = response?.data?.data?.company?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCompanyOptions(compOpt);
        const contactTypeOpt = response?.data?.data?.contact_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setContactTYpeOptions(contactTypeOpt);
        const countryOpt = response?.data?.data?.country?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCountryOptions(countryOpt);
        const deptOpt = response?.data?.data?.department?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDepartmentOptions(deptOpt);
        const subDeptOpt = response?.data?.data?.sub_department?.map((option) => ({
              label: option.text,
              value: option.value,
        }))
        setSubDepartmentOptions(subDeptOpt);
        const desigOpt = response?.data?.data?.designation?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDesignationOptions(desigOpt);
        const empOpt = response?.data?.data?.employee_type?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setEmployeeTypeOptions(empOpt);
        const genderOpt = response?.data?.data?.gender?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGenderOptions(genderOpt);
        const gstTypeOpt = response?.data?.data?.gstRegType?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGstRegTypeOptions(gstTypeOpt);
        const identityIssueOpt =
          response?.data?.data?.identityIssueingCountry?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setIdentityIssueingOptions(identityIssueOpt);
        const identityTypeOpt = response?.data?.data?.identityType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setIdentityTypeOptions(identityTypeOpt);
        const immediateManagerOpt =
          response?.data?.data?.immediate_manager?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setImmediateSuperiorOptions(immediateManagerOpt);
        const leaveAcrualTypeOpt = response?.data?.data?.leaveAcrualType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setLeaveAcrualTypeOptions(leaveAcrualTypeOpt);
        const maritialStatusOpt = response?.data?.data?.maritial_status?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setMaritialStatusOptions(maritialStatusOpt);
        const nationalityOpt = response?.data?.data?.nationality?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setNationalityOptions(nationalityOpt);
        const referOpt = response?.data?.data?.referredBy?.map((option) => ({
          label: option.TEXT,
          value: option.VALUE,
        }));
        setReferedByOptions(referOpt);
        const reletionTypeOpt = response?.data?.data?.relationType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelationTypeOptions(reletionTypeOpt);
        const relievingTypeOpt = response?.data?.data?.relievingType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelievingTypeOptions(relievingTypeOpt);
        const shiftsOpt = response?.data?.data?.shifts?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setShiftsOptions(shiftsOpt);
        const stateOpt = response?.data?.data?.state?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setStateOptions(stateOpt);
        const workingStatOpt = response?.data?.data?.workingStatus?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setWorkingStatusOptions(workingStatOpt);
        const bankOpt = response?.data?.data?.bank?.map((option) => ({
          label: option.Name,
          value: option.ID,
        }));
        setBankOptions(bankOpt);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

    const fetchSubDepartment = async (deptId) => {
        try {

            if (!deptId) return;

            setSubDepartmentOptions([]);

            const res = await GetServiceCaller(
                `${API_URL}sub-department/${deptId}`
            );

            const data = res.data.data;

            const formattedOptions = data
                .filter(item => item.ID !== null && item.Name !== null)
                .map((item) => ({
                    value: String(item.ID),
                    label: item.Name,
                }));
            console.log('formatted', formattedOptions);

            setSubDepartmentOptions(formattedOptions);

        } catch (error) {
            console.error(error);
        }
    };
    
    const fetchEmployeeDetails = async (id) => {
        try {
            const response = await GetServiceCaller(
                `${API_URL}rujul/employee-data/${id}`
            );

            if (response.status === 200 && response?.data?.data?.contactDetails) {
                const fetchEmpConatctData = response?.data?.data?.contactDetails;
                const fetchEmpData = response?.data?.data?.employeeDetails;
                const fetchEmpAddressData = response?.data?.data?.employeeAddress;
                const fetchAttachment = response?.data?.data?.employeeAttachment;
                const fetchBankData = response?.data?.data?.employeeBank;
                const fetchWorkingDetails =
                    response?.data?.data?.employeeExecutivesDetails;
                const fetchQualificationDetails =
                    response?.data?.data?.employeeQualification;
                const fetchEmpIdentitiesDetails =
                    response?.data?.data?.employeeIdentities;
                const fetchEmpHistoryDetails = response?.data?.data?.EmployeeHistory;

                const empHistoryData = fetchEmpHistoryDetails
                    ? Array.isArray(fetchEmpHistoryDetails)
                        ? fetchEmpHistoryDetails.map((item) => ({
                            ID: item.ID || "",
                            Branch: item.BranchID || "",
                            ShiftID: item.ShiftID || "",
                            DepartmentID: item.DepartmentID || "",
                            SubDepartmentID: item.SubDepartmentID || "",
                            DesignationID: item.DesignationID || "",
                            ImmediateSuperiorID: item.ImmediateSuperiorID || "",
                            FromDate: item.FromDate
                                ? moment(item.FromDate).format("DD-MMM-YYYY")
                                : "",
                            ToDate: item.ToDate
                                ? moment(item.ToDate).format("DD-MMM-YYYY")
                                : "",
                            LineNo: item.LineNo || "1",
                        }))
                        : [
                            {
                                ID: fetchEmpHistoryDetails.ID || "",
                                Branch: fetchEmpHistoryDetails.BranchID || "",
                                ShiftID: fetchEmpHistoryDetails.ShiftID || "",
                                DepartmentID: fetchEmpHistoryDetails.DepartmentID || "",
                                SubDepartmentID: fetchEmpHistoryDetails.SubDepartmentID || "",
                                DesignationID: fetchEmpHistoryDetails.DesignationID || "",
                                ImmediateSuperiorID:
                                    fetchEmpHistoryDetails.ImmediateSuperiorID || "",
                                FromDate: fetchEmpHistoryDetails.FromDate
                                    ? moment(fetchEmpHistoryDetails.FromDate).format(
                                        "DD-MMM-YYYY"
                                    )
                                    : "",
                                // ToDate: fetchEmpHistoryDetails.ToDate || "",
                                ToDate: fetchEmpHistoryDetails.ToDate
                                    ? moment(fetchEmpHistoryDetails.ToDate).format(
                                        "DD-MMM-YYYY"
                                    )
                                    : "",
                                LineNo: fetchEmpHistoryDetails.LineNo || "1",
                            },
                        ]
                    : [];

                const identitiesData = fetchEmpIdentitiesDetails
                    ? Array.isArray(fetchEmpIdentitiesDetails)
                        ? fetchEmpIdentitiesDetails.map((item) => ({
                            ID: item.ID || "",
                            IdentityType_063: item.IdentityType_063 || "",
                            NameOnIdentity: item.NameOnIdentity || "",
                            IdentityNo: item.IdentityNo || "",
                            IssuingCountry: item.IssuingCountry || "",
                            IssueDate: item.IssueDate
                                ? moment(item.IssueDate).format("DD-MMM-YYYY")
                                : "",
                            ExpiryDate: item.ExpiryDate
                                ? moment(item.ExpiryDate).format("DD-MMM-YYYY")
                                : "",
                            LineNo: item.LineNo || "1",
                        }))
                        : [
                            {
                                ID: fetchEmpIdentitiesDetails.ID || "",
                                IdentityType_063:
                                    fetchEmpIdentitiesDetails.IdentityType_063 || "",
                                NameOnIdentity:
                                    fetchEmpIdentitiesDetails.NameOnIdentity || "",
                                IdentityNo: fetchEmpIdentitiesDetails.IdentityNo || "",
                                LineNo: fetchEmpIdentitiesDetails.LineNo || "1",
                                IssuingCountry:
                                    fetchEmpIdentitiesDetails.IssuingCountry || "",
                                IssueDate: fetchEmpIdentitiesDetails.IssueDate
                                    ? moment(fetchEmpIdentitiesDetails.IssueDate).format(
                                        "DD-MMM-YYYY"
                                    )
                                    : "",

                                ExpiryDate: fetchEmpIdentitiesDetails.ExpiryDate
                                    ? moment(fetchEmpIdentitiesDetails.ExpiryDate).format(
                                        "DD-MMM-YYYY"
                                    )
                                    : "",
                            },
                        ]
                    : [];

                const eduData = fetchQualificationDetails
                    ? Array.isArray(fetchQualificationDetails)
                        ? fetchQualificationDetails.map((item) => ({
                            ID: item.ID || "",
                            QualificationType: item.QualificationType || "",
                            Qualification: item.Qualification || "",
                            Stream: item.Stream || "",
                            Institute: item.Institute || "",
                            Percentage: item.Percentage || "",
                            YearOfPassing: item.YearOfPassing || "",
                            University: item.University || "",
                            LineNo: item.LineNo || "1",
                        }))
                        : [
                            {
                                ID: fetchQualificationDetails.ID || "",
                                QualificationType:
                                    fetchQualificationDetails.QualificationType || "",
                                Qualification: fetchQualificationDetails.Qualification || "",
                                Stream: fetchQualificationDetails.Stream || "",
                                Institute: fetchQualificationDetails.Institute || "",
                                Percentage: fetchQualificationDetails.Percentage || "",
                                YearOfPassing: fetchQualificationDetails.YearOfPassing || "",
                                University: fetchQualificationDetails.University || "",
                                LineNo: fetchQualificationDetails.LineNo || "1",
                            },
                        ]
                    : [];

                const workingData = fetchWorkingDetails
                    ? Array.isArray(fetchWorkingDetails)
                        ? fetchWorkingDetails.map((item) => ({
                            ID: item.ID || "",
                            Company: item.CompanyID || "",
                            Branch: item.BranchID || "",
                            EmployeeType_069: item.EmployeeType_069 || "",
                            LineNo: item.LineNo || "1",
                        }))
                        : [
                            {
                                ID: fetchWorkingDetails.ID || "",
                                Company: fetchWorkingDetails.CompanyID || "",
                                Branch: fetchWorkingDetails.BranchID || "",
                                EmployeeType_069: fetchWorkingDetails.EmployeeType_069 || "",
                                LineNo: fetchWorkingDetails.LineNo || "1",
                            },
                        ]
                    : [];
                console.log("workingData", workingData);

                const bankData = fetchBankData
                    ? Array.isArray(fetchBankData)
                        ? fetchBankData.map((item) => ({
                            ID: item.ID || "",
                            IFSCCode: item.IFSCCode || "",
                            AccountNo: item.AccountNo || "",
                            Branch: item.Branch || "",
                            Bank: item.Bank || "",
                            DefaultBank: item.DefaultBank || 0,
                            LineNo: item.LineNo || "1",
                            PayTo: item.PayTo || "",
                        }))
                        : [
                            {
                                ID: fetchBankData.ID || "",
                                IFSCCode: fetchBankData.IFSCCode || "",
                                AccountNo: fetchBankData.AccountNo || "",
                                Branch: fetchBankData.Branch || "",
                                Bank: fetchEmpData.Bank || "",
                                DefaultBank: fetchBankData.DefaultBank || 0,
                                LineNo: fetchBankData.LineNo || "1",
                                PayTo: fetchEmpConatctData.PayTo || "",
                            },
                        ]
                    : [];

                // Ensure values are not undefined
                const formDataEdit = {
                    ...initialFormData,

                    files: fetchAttachment
                        ? fetchAttachment.map((file) => ({
                            name: file.FileName
                                ? file.FileName.split("/")
                                    .pop()
                                    .split("_")
                                    .slice(-2)
                                    .join("_") // Extract required part of filename
                                : "",
                            size: file.FileSize
                                ? (file.FileSize / 1024 / 1024).toFixed(2) + " MB"
                                : "0 MB", // Convert file size to MB format
                            filePath: file.FileName,
                            FileData: file.FileData,
                        }))
                        : [],
                    filesize: fetchAttachment
                        ? fetchAttachment.map((file) =>
                            file.FileSize
                                ? (file.FileSize / 1024 / 1024).toFixed(2) + " MB"
                                : "0 MB"
                        )
                        : [],

                    Title: fetchEmpConatctData.Salutation_019,
                    FirstName: fetchEmpConatctData.FirstName,
                    MiddleName: fetchEmpConatctData.MiddleName,
                    LastName: fetchEmpConatctData.LastName,
                    FatherName: fetchEmpData.FatherName,
                    UploadProfileImg: fetchEmpData.ProfileImage,
                    FatherDOB: fetchEmpData?.FatherDOB
                        ? moment(fetchEmpData.FatherDOB).format("DD-MMM-YYYY")
                        : null,
                    MotherName: fetchEmpData.MotherName,
                    MotherDOB: fetchEmpData?.MotherDOB
                        ? moment(fetchEmpData.MotherDOB).format("DD-MMM-YYYY")
                        : null,
                    ContactType_011: Number(fetchEmpConatctData.ContactType_011),
                    IsInActive: fetchEmpData?.IsInActive,
                    AccountType: fetchEmpConatctData.AccountID,
                    Gender_020: fetchEmpConatctData.Gender_020,
                    DateOfBirth: fetchEmpConatctData?.DateOfBirth
                        ? moment(fetchEmpConatctData.DateOfBirth).format("DD-MMM-YYYY")
                        : "",
                    MobileNo1: fetchEmpConatctData?.MobileNo1
                        ? fetchEmpConatctData.MobileNo1.replace(/\D/g, "").slice(-10)
                        : "",
                    MobileNo2: fetchEmpConatctData?.MobileNo2
                        ? fetchEmpConatctData.MobileNo2.replace(/\D/g, "").slice(-10)
                        : "",
                    DeskPhoneNo: fetchEmpAddressData[0]?.PhoneNo1
                        ? fetchEmpAddressData[0].PhoneNo1.replace(/\D/g, "").slice(-10)
                        : "",
                    EmergencyPhoneNo: fetchEmpData?.EmergencyPhoneNo
                        ? fetchEmpData.EmergencyPhoneNo.replace(/\D/g, "").slice(-10)
                        : "",
                    EmergencyContactName: fetchEmpData?.EmergencyContactName,
                    EmergencyContactRelation: fetchEmpData?.EmergencyContactRelation,
                    OfficeEmail: fetchEmpConatctData?.Email,
                    PersonalEmail: fetchEmpConatctData?.AlternateEMail,
                    Location: fetchEmpAddressData[0]?.Location,
                    IsIntern: fetchEmpConatctData?.IsIntern ? "1" : "0",
                    IsPartTime: fetchEmpData?.IsPartTime ? "1" : "0",
                    OnPayroll: fetchEmpData?.OnPayroll ? "1" : "0",
                    // Correspondence Address
                    CorrespondenceAddress: fetchEmpAddressData[0]?.AddressLine2,
                    CorrespondenceCountry: fetchEmpAddressData[0]?.CountryID,
                    CorrespondenceState: fetchEmpAddressData[0]?.StateID,
                    CorrespondenceCity: fetchEmpAddressData[0]?.CityID,
                    CorrespondenceZipCode: fetchEmpAddressData[0]?.ZipCode,
                    CorrespondenceAddressPrint: fetchEmpAddressData[0]?.PrintAddress,
                    // Permanent Address
                    permanentAddressCode: fetchEmpAddressData[1]?.AddressLine2,
                    permanentAddressCountryID: fetchEmpAddressData[1]?.CountryID,
                    permanentAddressStateID: fetchEmpAddressData[1]?.StateID,
                    permanentAddressCityID: fetchEmpAddressData[1]?.CityID,
                    permanentAddressZipCode: fetchEmpAddressData[1]?.ZipCode,
                    permanentPrintAddress: fetchEmpAddressData[1]?.PrintAddress,
                    GSTNo: fetchEmpAddressData?.GSTNo,
                    VATNo: fetchEmpAddressData?.VATNo,
                    CSTNo: fetchEmpAddressData?.CSTNo,
                    PANNo: fetchEmpAddressData?.PANNo,
                    GSTEffectiveDate: fetchEmpAddressData?.GSTEffectiveDate
                        ? moment(fetchEmpAddressData.GSTEffectiveDate).format("DD-MMM-YYYY")
                        : "",
                    VATEffectiveDate: fetchEmpAddressData?.VATEffectiveDate
                        ? moment(fetchEmpAddressData.VATEffectiveDate).format("DD-MMM-YYYY")
                        : "",
                    CSTEffectiveDate: fetchEmpAddressData?.CSTEffectiveDate
                        ? moment(fetchEmpAddressData.CSTEffectiveDate).format("DD-MMM-YYYY")
                        : "",
                    STNo: fetchEmpAddressData?.STNo,
                    GSTRegistrationType_192: fetchEmpAddressData?.GSTRegistrationType_192,
                    STEffectiveDate: fetchEmpAddressData?.STEffectiveDate
                        ? moment(fetchEmpAddressData.STEffectiveDate).format("DD-MMM-YYYY")
                        : "",
                    LeaveAccrualType_155: fetchEmpData?.LeaveAccrualType_155,
                    WorkingStatus: fetchEmpData?.EmployeeCategory_057,
                    RelivingType_119: fetchEmpData?.RelivingType_119,
                    ResignationDate: fetchEmpData?.ResignationDate
                        ? moment(fetchEmpData.ResignationDate).format("DD-MMM-YYYY")
                        : "",
                    ReferBy: fetchEmpData?.ReferBy,
                    ConfirmationDate: fetchEmpData?.ConfirmationDate
                        ? moment(fetchEmpData.ConfirmationDate).format("DD-MMM-YYYY")
                        : "",
                    RelivingDate: fetchEmpData?.RelivingDate
                        ? moment(fetchEmpData.RelivingDate).format("DD-MMM-YYYY")
                        : "",
                    BloodGroup_062: fetchEmpData?.BloodGroup_062,
                    MaritalStatus_021: fetchEmpConatctData?.MaritalStatus_021,
                    Nationality: fetchEmpData?.Nationality_061 || null,
                    BranchID: fetchEmpConatctData?.BranchID,
                    DateOfAnniversary: fetchEmpConatctData?.DateOfAnniversary
                        ? moment(fetchEmpConatctData.DateOfAnniversary).format(
                            "DD-MMM-YYYY"
                        )
                        : "",
                    AppointmentDate: fetchEmpData?.AppointmentDate
                        ? moment(fetchEmpData.AppointmentDate).format("DD-MMM-YYYY")
                        : "",
                    JoiningDate: fetchEmpData?.JoiningDate
                        ? moment(fetchEmpData.JoiningDate).format("DD-MMM-YYYY")
                        : "",
                    PayrollJoiningDate: fetchEmpData?.PayrollJoiningDate
                        ? moment(fetchEmpData.PayrollJoiningDate).format("DD-MMM-YYYY")
                        : "",
                    employeebank:
                        bankData.length > 0 ? bankData : initialFormData.employeebank,
                    workingarea:
                        workingData.length > 0 ? workingData : initialFormData.workingarea,

                    qualification:
                        eduData.length > 0 ? eduData : initialFormData.qualification,
                    identities:
                        identitiesData.length > 0
                            ? identitiesData
                            : initialFormData.identities,
                    employeeDetails:
                        empHistoryData.length > 0
                            ? empHistoryData
                            : initialFormData.employeeDetails,
                };
                console.log("Setting formData:", formDataEdit);

                const corrAddress = fetchEmpAddressData?.[0] || {};
                const permAddress = fetchEmpAddressData?.[1] || {};

                const isSameAddress =
                    corrAddress.AddressCode == permAddress.AddressCode &&
                    corrAddress.CityID == permAddress.CityID &&
                    corrAddress.ZipCode == permAddress.ZipCode &&
                    corrAddress.PrintAddress == permAddress.PrintAddress;
                console.log("isSameAddress", isSameAddress);

                setFormData(formDataEdit);
                const updatedData = isSameAddress ? 1 : 0;
                setFormData((prev) => ({
                    ...prev,
                    IsCopyAddress: isSameAddress ? 1 : 0,
                }));
                console.log("updatedData", updatedData);
            } else {
                console.error(
                    "Failed to fetch employee data. Status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    };

    const rawStringToBlob = (rawString, contentType = "application/pdf") => {
        const byteNumbers = new Array(rawString.length);
        for (let i = 0; i < rawString.length; i++) {
            byteNumbers[i] = rawString.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    };

    const handleBlobDownload = async (file) => {
        try {
            let blob;

            if (file.FileData) {
                // file.FileData is raw string (not base64)
                blob = rawStringToBlob(file.FileData, "application/pdf");
            } else if (file.filePath) {
                const response = await fetch(file.filePath);
                blob = await response.blob();
            } else {
                console.error("No file data or path available.");
                return;
            }

            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file.name || "downloaded_file.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("File download failed", error);
        }
    };

   
        return (
            <>
                <div className="container-fluid" id="skill_section">
                    <form
                        id="formOne"
                        className="rounded mt-4 bg-white"
                    >
                        <div className="container-fluid overflow-x-auto">
                            <ul
                                className="nav nav-tabs flex flex-nowrap w-max space-x-2"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        style={{ color: "#2F2E4B" }}
                                        id="general-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#general"
                                        type="button"
                                        role="tab"
                                        aria-controls="general"
                                        aria-selected="true"
                                    >
                                        General
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="personal-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#personal"
                                        type="button"
                                        role="tab"
                                        aria-controls="personal"
                                        aria-selected="false"
                                    >
                                        Contact
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="project-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#project"
                                        type="button"
                                        role="tab"
                                        aria-controls="project"
                                        aria-selected="false"
                                    >
                                        Bank
                                    </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="rating-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#rating"
                    type="button"
                    role="tab"
                    aria-controls="rating"
                    aria-selected="false"
                  >
                    Tax
                  </button>
                </li> */}
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="other-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#other"
                                        type="button"
                                        role="tab"
                                        aria-controls="other"
                                        aria-selected="false"
                                    >
                                        HR
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="areas-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#areas"
                                        type="button"
                                        role="tab"
                                        aria-controls="areas"
                                        aria-selected="false"
                                    >
                                        Working Location
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="attachment-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#attachment"
                                        type="button"
                                        role="tab"
                                        aria-controls="attachment"
                                        aria-selected="false"
                                    >
                                        Attachments
                                    </button>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="qualification-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#qualification"
                                        type="button"
                                        role="tab"
                                        aria-controls="qualification"
                                        aria-selected="false"
                                    >
                                        Qualification
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="identities-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#identities"
                                        type="button"
                                        role="tab"
                                        aria-controls="identities"
                                        aria-selected="false"
                                    >
                                        Identities
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        style={{ color: "#2F2E4B" }}
                                        id="additional-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#additional"
                                        type="button"
                                        role="tab"
                                        aria-controls="additional"
                                        aria-selected="false"
                                    >
                                        Additional
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content" id="myTabContent">
                            {/* General Details */}
                            <div
                                className="tab-pane fade show active"
                                id="general"
                                role="tabpanel"
                                aria-labelledby="general-tab"
                            >
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label className="form-label">
                                                        Title <span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        name="Title"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...titleOptions,
                                                        ]}
                                                        className={` ${errors.Salutation_019 ? "is-invalid" : ""
                                                            }`}
                                                        value={titleOptions.find(
                                                            (option) => option.value === formData?.Title
                                                        )}

                                                        isDisabled={true}
                                                    />
                                                    {errors.Salutation_019 && (
                                                        <div className="error">{errors.Salutation_019}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="FirstName" className="form-label">
                                                            First Name
                                                            <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="First Name"
                                                            className="form-control"
                                                            id="FirstName"
                                                            name="FirstName"
                                                            disabled
                                                            value={formData?.FirstName}
                                                        />
                                                        {errors.FirstName && (
                                                            <div className="error">{errors.FirstName}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="MiddleName" className="form-label">
                                                            Middle Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Middle Name"
                                                            className="form-control"
                                                            disabled
                                                            id="MiddleName"
                                                            name="MiddleName"
                                                            value={formData?.MiddleName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="LastName" className="form-label">
                                                            Last Name
                                                            <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled
                                                            placeholder="Last Name"
                                                            className="form-control"
                                                            id="LastName"
                                                            name="LastName"
                                                            value={formData?.LastName}
                                                        />
                                                        {errors.LastName && (
                                                            <div className="error">{errors.LastName}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="FatherName" className="form-label">
                                                            Father Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            disabled
                                                            placeholder="Father's Name"
                                                            className="form-control"
                                                            id="FatherName"
                                                            name="FatherName"
                                                            value={formData?.FatherName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="FatherDOB" className="form-label">
                                                            Father's DOB
                                                        </label>
                                                        <CustomDatePicker
                                                            name="FatherDOB"
                                                            readOnly id="FatherDOB"
                                                            placeholderText="DD-MMM-YYYY"
                                                            className="form-control"
                                                            value={formData?.FatherDOB || null}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="MotherName" className="form-label">
                                                            Mother Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Mother's Name"
                                                            className="form-control"
                                                            id="MotherName"
                                                            disabled
                                                            name="MotherName"
                                                            value={formData?.MotherName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="MotherDOB" className="form-label">
                                                            Mother's DOB
                                                        </label>
                                                        <CustomDatePicker
                                                            name="MotherDOB"
                                                            readOnly
                                                            id="MotherDOB"
                                                            value={formData?.MotherDOB}
                                                            placeholderText="DD-MMM-YYYY"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="">
                                                        <label className="form-label">
                                                            Contact Type <span className="required">*</span>
                                                        </label>
                                                        <Select
                                                            isDisabled
                                                            name="ContactType_011"
                                                            options={[
                                                                { value: "", label: "Select" },
                                                                ...conatctTypeOptions,
                                                            ]}
                                                            className={` ${errors.ContactType_011 ? "is-invalid" : ""
                                                                }`}
                                                            value={conatctTypeOptions.find(
                                                                (option) =>
                                                                    option.value === formData?.ContactType_011
                                                            )}
                                                        // value={formData?.ContactType}

                                                        />

                                                        {errors.ContactType_011 && (
                                                            <div className="error">
                                                                {errors.ContactType_011}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="">
                                                        <label className="form-label">
                                                            Account <span className="required">*</span>
                                                        </label>
                                                        <Select

                                                            isDisabled
                                                            name="AccountType"
                                                            options={[
                                                                { value: "", label: "Select" },
                                                                ...accountTypeOption,
                                                            ]}
                                                            // value={formData?.AccountType}
                                                            value={accountTypeOption.find(
                                                                (option) =>
                                                                    option.value === formData?.AccountType
                                                            )}
                                                            className={` ${errors.AccountType ? "is-invalid" : ""
                                                                }`}

                                                        />
                                                        {errors.AccountType && (
                                                            <div className="error">{errors.AccountType}</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-sm-2">
                                                    <div className="">
                                                        <label className="form-label">
                                                            Gender <span className="required">*</span>
                                                        </label>
                                                        <Select

                                                            isDisabled
                                                            name="Gender_020"
                                                            // value={formData?.Gender_020}
                                                            value={genderOptions.find(
                                                                (option) =>
                                                                    option.value === formData?.Gender_020
                                                            )}

                                                            className={` ${errors.Gender_020 ? "is-invalid" : ""
                                                                }`}
                                                            options={[
                                                                { value: "", label: "Select" },
                                                                ...genderOptions,
                                                            ]}
                                                        />
                                                        {errors.Gender_020 && (
                                                            <div className="error">{errors.Gender_020}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <label className="form-label">
                                                        Date Of Birth<span className="required">*</span>
                                                    </label>
                                                    <CustomDatePicker
                                                        readOnly
                                                        name="DateOfBirth"
                                                        id="DateOfBirth"
                                                        placeholderText="DD-MMM-YYYY"
                                                        value={formData?.DateOfBirth}

                                                        required={true}
                                                        className={`form-control ${errors?.DateOfBirth ? "is-invalid" : ""
                                                            }`}
                                                    />
                                                    {errors.DateOfBirth && (
                                                        <span class="error">{errors?.DateOfBirth}</span>
                                                    )}
                                                </div>
                                                <div className="col-sm-2">
                                                    <label htmlFor="IsInActive" className="form-label">
                                                        Active
                                                    </label>
                                                    <div className="me-2 mt-0">
                                                        <div className="d-flex">
                                                            <div className="form-check me-2" key={"Yes"}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    disabled
                                                                    name="IsInActive"
                                                                    id="rating_1_yes"
                                                                    value={1}
                                                                    checked={formData?.IsInActive === 1}

                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="rating_1_yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check me-2" key={"No"}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    disabled
                                                                    name="IsInActive"
                                                                    id="rating_1_No"
                                                                    value={0}
                                                                    checked={formData?.IsInActive === 0}

                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="rating_1_No"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-sm-2 text-center mt-4">
                                            <ProfileInput
                                                isDisabled={true}
                                                // handleProfilePic={handleProfilePic}
                                                image={formData?.UploadProfileImg}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Details */}
                            <div
                                className="tab-pane fade show"
                                id="personal"
                                role="tabpanel"
                                aria-labelledby="personal-tab"
                            >
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Mobile No. 1 <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    disabled
                                                    name="MobileNo1"
                                                    placeholder="Mobile No. 1"
                                                    className="form-control"
                                                    value={formData?.MobileNo1}

                                                />
                                                {errors.MobileNo1 && (
                                                    <div className="error">{errors.MobileNo1}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">Mobile No. 2</label>
                                                <input
                                                    disabled
                                                    type="number"
                                                    name="MobileNo2"
                                                    placeholder="Desk Phone No."
                                                    className="form-control"
                                                    value={formData?.MobileNo2}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">Desk Phone No.</label>
                                                <input
                                                    disabled
                                                    type="number"
                                                    name="DeskPhoneNo"
                                                    placeholder="Desk Phone No."
                                                    value={formData?.DeskPhoneNo}

                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Emergency Phone No.<span className="required">*</span>
                                                </label>

                                                <input
                                                    disabled
                                                    type="number"
                                                    placeholder="Emergency Contact No."
                                                    className="form-control"
                                                    name="EmergencyPhoneNo"
                                                    value={formData?.EmergencyPhoneNo}

                                                />
                                                {errors.EmergencyPhoneNo && (
                                                    <div className="error">{errors.EmergencyPhoneNo}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Emergency Contact Name
                                                    <span className="required">*</span>
                                                </label>
                                                <input
                                                    disabled
                                                    placeholder="Emergency Contact Name"
                                                    className="form-control"
                                                    type="text"
                                                    name="EmergencyContactName"
                                                    value={formData?.EmergencyContactName}

                                                />
                                                {errors.EmergencyContactName && (
                                                    <div className="error">
                                                        {errors.EmergencyContactName}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Contact Relation<span className="required">*</span>
                                                </label>
                                                <input
                                                    disabled
                                                    placeholder="Emergency Contact Relation"
                                                    className="form-control"
                                                    type="text"
                                                    name="EmergencyContactRelation"
                                                    value={formData?.EmergencyContactRelation}

                                                />
                                                {errors.EmergencyContactRelation && (
                                                    <div className="error">
                                                        {errors.EmergencyContactRelation}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Personal Email<span className="required">*</span>
                                                </label>
                                                <input
                                                    disabled
                                                    placeholder="Personal Email"
                                                    className="form-control"
                                                    type="text"
                                                    name="PersonalEmail"
                                                    value={formData?.PersonalEmail}

                                                />
                                                {errors.PersonalEmail && (
                                                    <div className="error">{errors.PersonalEmail}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    NSS Email <span className="required">*</span>
                                                </label>
                                                <input
                                                    disabled
                                                    placeholder="Official Email"
                                                    className="form-control"
                                                    type="text"
                                                    name="OfficeEmail"
                                                    value={formData?.OfficeEmail}

                                                />
                                                {errors.OfficeEmail && (
                                                    <div className="error">{errors.OfficeEmail}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label className="form-label">Location</label>
                                                <input
                                                    disabled
                                                    placeholder="Location"
                                                    className="form-control"
                                                    type="text"
                                                    name="Location"
                                                    value={formData?.Location}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <div className="mt-4">
                                                    <div className="form-check">
                                                        <input
                                                            disabled
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="IsRemotly"
                                                            id="IsRemotly"
                                                            checked={formData?.IsRemotly === "1"}

                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="IsRemotly"
                                                        >
                                                            Is Working Remotely?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {/* Correspondence Address Section */}
                                        <div className="col-sm-6">
                                            <p>
                                                <strong>Correspondence Address</strong>
                                            </p>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="">
                                                        <label className="form-label">Address Type</label>
                                                        <Select
                                                            isDisabled={true}
                                                            name="CorrepondenceAddressType"
                                                            options={[
                                                                { value: "", label: "Select" },
                                                                ...addressTypeOptions,
                                                            ]}
                                                            value={addressTypeOptions.find(
                                                                (option) =>
                                                                    option.value ===
                                                                    formData?.CorrepondenceAddressType
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            Address<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            disabled
                                                            type="text"
                                                            className="form-control"
                                                            name="CorrespondenceAddress"
                                                            placeholder="Address"
                                                            value={formData?.CorrespondenceAddress}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        Country<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        type="text"
                                                        name="CorrespondenceCountry"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...countryOptions,
                                                        ]}
                                                        // value={formData.Country}
                                                        value={countryOptions.find(
                                                            (option) =>
                                                                option.value === formData?.CorrespondenceCountry
                                                        )}

                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        State<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        type="text"
                                                        name="CorrespondenceState"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...stateOptions,
                                                        ]}
                                                        value={stateOptions.find(
                                                            (option) =>
                                                                option.value === formData?.CorrespondenceState
                                                        )}

                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        City<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        name="CorrespondenceCity"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...cityOptions,
                                                        ]}
                                                        value={cityOptions.find(
                                                            (option) =>
                                                                option.value === formData?.CorrespondenceCity
                                                        )}

                                                    />
                                                    {/* {errors?.CorrespondenceCity?.status && (
                                                               <span className="error">
                                                                   {errors?.CorrespondenceCity?.message}
                                                               </span>
                                                           )} */}
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Zip Code</label>
                                                        <input
                                                            disabled
                                                            type="text"
                                                            className="form-control"
                                                            name="CorrespondenceZipCode"
                                                            placeholder="Zipcode"
                                                            value={formData?.CorrespondenceZipCode}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label className="form-label">Print Address</label>
                                                        <input
                                                            disabled
                                                            className="form-control"
                                                            type="text"
                                                            name="CorrespondenceAddressPrint"
                                                            value={formData?.CorrespondenceAddressPrint}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Permanent Address Section */}
                                        <div className="col-sm-6">
                                            <p className="d-flex gap-1">
                                                <strong>Permanent Address</strong>(
                                                <div>
                                                    <div class="form-check">
                                                        <input
                                                            disabled
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            name="IsCopyAddress"
                                                            value="1"
                                                            id="IsCopyAddress"
                                                            checked={formData?.IsCopyAddress == 1}
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked;

                                                                // Validation: Check if correspondence address and city are provided
                                                                if (
                                                                    isChecked &&
                                                                    (!formData?.CorrespondenceAddress ||
                                                                        !formData?.CorrespondenceCity)
                                                                ) {
                                                                    toast.error(
                                                                        "Please enter First Correspondence Address"
                                                                    );
                                                                    return;
                                                                }


                                                                if (isChecked) {
                                                                    setFormData((prevData) => ({
                                                                        ...prevData,
                                                                        IsCopyAddress: 1, // Ensure checkbox state updates
                                                                        permanentAddressCode:
                                                                            prevData.CorrespondenceAddress || "",
                                                                        permanentAddressCountryID:
                                                                            prevData.CorrespondenceCountry || "",
                                                                        permanentAddressStateID:
                                                                            prevData.CorrespondenceState || "",
                                                                        permanentAddressCityID:
                                                                            prevData.CorrespondenceCity || "",
                                                                        permanentAddressZipCode:
                                                                            prevData.CorrespondenceZipCode || "",
                                                                        permanentPrintAddress:
                                                                            prevData.CorrespondenceAddressPrint || "",
                                                                    }));
                                                                } else {
                                                                    setFormData((prevData) => ({
                                                                        ...prevData,
                                                                        IsCopyAddress: 0,
                                                                        permanentAddressCode: "",
                                                                        permanentAddressCountryID: "",
                                                                        permanentAddressStateID: "",
                                                                        permanentAddressCityID: "",
                                                                        permanentAddressZipCode: "",
                                                                        permanentPrintAddress: "",
                                                                    }));
                                                                }
                                                            }}
                                                        />

                                                        <label class="form-check-label" for="IsCopyAddress">
                                                            Is Same as Correspondence Address?)
                                                        </label>
                                                    </div>
                                                </div>
                                            </p>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="">
                                                        <label className="form-label">Address Type</label>
                                                        <Select
                                                            isDisabled={true}
                                                            name="PermanentAddressType"
                                                            options={[
                                                                { value: "", label: "Select" },
                                                                ...addressTypeOptions,
                                                            ]}
                                                            value={addressTypeOptions.find(
                                                                (option) =>
                                                                    option.value ===
                                                                    formData?.PermanentAddressType
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            Address <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            disabled
                                                            type="text"
                                                            name="permanentAddressCode"
                                                            value={formData?.permanentAddressCode}
                                                            className="form-control"
                                                            placeholder="Address"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        Country<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        type="text"
                                                        name="permanentAddressCountryID"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...countryOptions,
                                                        ]}
                                                        // value={formData.Country}
                                                        value={countryOptions.find(
                                                            (option) =>
                                                                option.value ===
                                                                formData?.permanentAddressCountryID
                                                        )}

                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        State<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        type="text"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...stateOptions,
                                                        ]}
                                                        value={stateOptions.find(
                                                            (option) =>
                                                                option.value ===
                                                                formData?.permanentAddressStateID
                                                        )}
                                                        name="permanentAddressStateID"

                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label">
                                                        City<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        isDisabled
                                                        name="permanentAddressCityID"
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...cityOptions,
                                                        ]}
                                                        value={cityOptions.find(
                                                            (option) =>
                                                                option.value ===
                                                                formData?.permanentAddressCityID
                                                        )}

                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Zip Code</label>
                                                        <input
                                                            disabled
                                                            type="text"
                                                            className="form-control"
                                                            name="permanentAddressZipCode"
                                                            value={formData?.permanentAddressZipCode}
                                                            placeholder="Zipcode"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label className="form-label">Print Address</label>
                                                        <input
                                                            disabled
                                                            className="form-control"
                                                            type="text"
                                                            name="permanentPrintAddress"
                                                            value={formData?.permanentPrintAddress}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bank Details */}
                            <div
                                className="tab-pane fade show"
                                id="project"
                                role="tabpanel"
                                aria-labelledby="project-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">

                                                <div className="table-responsive poc-head rounded">
                                                    <Table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "15%" }}>Pay To</th>
                                                                <th style={{ width: "15%" }}>
                                                                    Bank<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>Branch</th>
                                                                <th style={{ width: "15%" }}>
                                                                    Account No.<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>
                                                                    IFSC Code<span className="required">*</span>
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        width: "5%",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    Default
                                                                </th>
                                                                <th style={{ width: "5%" }}>Del</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.employeebank &&
                                                                formData.employeebank.map &&
                                                                formData.employeebank.map((line, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                type="text"
                                                                                placeholder="In case of contractor"
                                                                                className="form-control"
                                                                                name="PayTo"
                                                                                value={`${formData.FirstName || ""} ${formData.LastName || ""
                                                                                    }`.trim()}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                menuPlacement="top"
                                                                                styles={tableSelectStyle}
                                                                                menuPortalTarget={document.body}
                                                                                name="Bank"
                                                                                value={bankOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeebank[index].Bank
                                                                                )}
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...bankOptions,
                                                                                ]}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                type="text"
                                                                                placeholder="Branch"
                                                                                className="form-control"
                                                                                name="Branch"
                                                                                value={
                                                                                    formData.employeebank?.[index].Branch
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                type="number"
                                                                                placeholder="Account No"
                                                                                className={"form-control text-end"}
                                                                                name="AccountNo"
                                                                                value={
                                                                                    formData.employeebank[index].AccountNo
                                                                                }

                                                                                onKeyDown={(e) => {
                                                                                    if (
                                                                                        ["e", "E", "+", "-", "."].includes(
                                                                                            e.key
                                                                                        )
                                                                                    ) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                type="text"
                                                                                placeholder="IFSC Code"
                                                                                className={"form-control"}
                                                                                name="IFSCCode"
                                                                                value={
                                                                                    formData.employeebank[index].IFSCCode
                                                                                }

                                                                            ></input>

                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <input
                                                                                disabled
                                                                                class="form-check-input"
                                                                                type="checkbox"
                                                                                value="1"
                                                                                name="DefaultBank"
                                                                                id="DefaultBank"
                                                                                checked={
                                                                                    formData.employeebank[index]
                                                                                        .DefaultBank === 1
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <a

                                                                                className={
                                                                                    line.isDelete
                                                                                        ? "text-danger"
                                                                                        : "text-muted"
                                                                                }
                                                                                style={{
                                                                                    pointerEvents: line.isDelete
                                                                                        ? "auto"
                                                                                        : "none",
                                                                                    cursor: line.isDelete
                                                                                        ? "pointer"
                                                                                        : "not-allowed",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                                                        }`}
                                                                                ></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Tax Detail */}
                            {/* HR Details */}
                            <div
                                className="tab-pane fade show"
                                id="other"
                                role="tabpanel"
                                aria-labelledby="other-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">Working Status</label>
                                                    <Select
                                                        isDisabled
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...workingStatusOptions,
                                                        ]}
                                                        value={workingStatusOptions.find(
                                                            (option) =>
                                                                option.value === formData?.WorkingStatus
                                                        )}
                                                        name="WorkingStatus"

                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label">
                                                        Leave Acrual Type
                                                    </label>
                                                    <Select
                                                        isDisabled options={[
                                                            { value: "", label: "Select" },
                                                            ...leaveAcuralOptions,
                                                        ]}
                                                        value={leaveAcuralOptions.find(
                                                            (option) =>
                                                                option.value === formData?.LeaveAccrualType_155
                                                        )}
                                                        name="LeaveAccrualType_155"

                                                    />
                                                </div>
                                                <div className="col-sm-2">
                                                    <label className="form-label">Referred By</label>
                                                    <Select
                                                        isDisabled
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...referedByOptions,
                                                        ]}
                                                        value={referedByOptions.find(
                                                            (option) => option.value === formData?.ReferBy
                                                        )}
                                                        name="ReferBy"

                                                    />
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            Resignation Date
                                                        </label>
                                                        <CustomDatePicker
                                                            readOnly
                                                            name="ResignationDate"
                                                            id="ResignationDate"
                                                            placeholderText="DD-MMM-YYYY"
                                                            className="form-control"
                                                            value={formData?.ResignationDate}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            Resg. Acceptance Date
                                                        </label>
                                                        <CustomDatePicker
                                                            readOnly
                                                            name="ConfirmationDate"
                                                            id="ConfirmationDate"
                                                            placeholderText="DD-MMM-YYYY"
                                                            className="form-control"
                                                            value={formData.ConfirmationDate}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label className="form-label">Relieving Date</label>
                                                        <CustomDatePicker
                                                            readOnly
                                                            name="RelivingDate"
                                                            id="RelivingDate"
                                                            placeholderText="DD-MMM-YYYY"
                                                            className="form-control"
                                                            value={formData?.RelivingDate}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <label className="form-label">Relieving Type</label>
                                                    <Select
                                                        isDisabled
                                                        options={[
                                                            { value: "", label: "Select" },
                                                            ...relievingTypeOptions,
                                                        ]}
                                                        name="RelivingType_119"
                                                        value={relievingTypeOptions.find(
                                                            (option) =>
                                                                option.value === formData?.RelivingType_119
                                                        )}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="table-responsive poc-head rounded">
                                                    <Table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "12%" }}>
                                                                    Branch<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "12%" }}>
                                                                    Shift<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>
                                                                    Department<span className="required">*</span>
                                                                </th>
                                                                 <th style={{ width: "15%" }}>
                                                                    Sub Department<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>
                                                                    Designation<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "20%" }}>
                                                                    Immediate Superior
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "13%" }}>
                                                                    From Date<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "13%" }}>To Date</th>
                                                                <th style={{ width: "4%" }}>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.employeeDetails &&
                                                                formData.employeeDetails.map &&
                                                                formData.employeeDetails.map((line, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="Branch"
                                                                                // value={
                                                                                //   formData.employeeDetails[index].branch
                                                                                // }
                                                                                value={branchOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]
                                                                                            .Branch
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...branchOptions,
                                                                                ]}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="ShiftID"
                                                                                value={shiftsOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]
                                                                                            .ShiftID
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...shiftsOptions,
                                                                                ]}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="DepartmentID"

                                                                                value={departmentOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]                                 
                                                                                            .DepartmentID
                                                                                )}
                                                                                onChange={(selectedOption) => {

                                                                                    if (selectedOption) {
                                                                                        fetchSubDepartment(selectedOption.value);
                                                                                    }
                                                                                }}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...departmentOptions,
                                                                                ]}
                                                                            />
                                                                        </td>
                                                                         <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="SubDepartmentID"

                                                                                value={subDepartmentOptions.find(                                       
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]
                                                                                            .SubDepartmentID
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...subDepartmentOptions,
                                                                                ]}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                name="DesignationID"

                                                                                isDisabled value={designationOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]
                                                                                            .DesignationID
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...designationOptions,
                                                                                ]}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                name="ImmediateSuperiorID"
                                                                                isDisabled value={immediateSuperiorOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.employeeDetails[index]
                                                                                            .ImmediateSuperiorID
                                                                                )}

                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...immediateSuperiorOptions,
                                                                                ]}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <CustomDatePicker
                                                                                readOnly required={true}

                                                                                // index={index}
                                                                                module="employeeDetails"
                                                                                name="FromDate"
                                                                                value={
                                                                                    formData.employeeDetails[index]
                                                                                        .FromDate
                                                                                }
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <CustomDatePicker
                                                                                required={true}
                                                                                readOnly
                                                                                // index={index}
                                                                                module="employeeDetails"
                                                                                name="ToDate"
                                                                                value={
                                                                                    formData.employeeDetails[index].ToDate
                                                                                }
                                                                            />
                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <a

                                                                                className={
                                                                                    line.isDelete
                                                                                        ? "text-danger"
                                                                                        : "text-muted"
                                                                                }
                                                                                style={{
                                                                                    pointerEvents: line.isDelete
                                                                                        ? "auto"
                                                                                        : "none",
                                                                                    cursor: line.isDelete
                                                                                        ? "pointer"
                                                                                        : "not-allowed",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                                                        }`}
                                                                                ></i>
                                                                            </a>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Working Areas */}
                            <div
                                className="tab-pane fade show"
                                id="areas"
                                role="tabpanel"
                                aria-labelledby="areas-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">

                                                <div className="table-responsive poc-head rounded">
                                                    <Table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "32%" }}>
                                                                    Employee Type
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "32%" }}>
                                                                    Branch<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "32%" }}>Company</th>
                                                                <th style={{ width: "4%" }}>Del</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.workingarea &&
                                                                formData.workingarea.map &&
                                                                formData.workingarea.map((line, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <Select
                                                                                name="EmployeeType_069"
                                                                                isDisabled value={employeeTypeOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.workingarea[index]
                                                                                            .EmployeeType_069
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...employeeTypeOptions,
                                                                                ]}

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled name="Branch"
                                                                                // value={formData.workingarea[index].branch}
                                                                                value={branchOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.workingarea[index].Branch
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...branchOptions,
                                                                                ]}

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="Company"


                                                                                value={companyOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.workingarea[index].Company
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...companyOptions,
                                                                                ]}
                                                                            />

                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <a

                                                                                className={
                                                                                    line.isDelete
                                                                                        ? "text-danger"
                                                                                        : "text-muted"
                                                                                }
                                                                                style={{
                                                                                    pointerEvents: line.isDelete
                                                                                        ? "auto"
                                                                                        : "none",
                                                                                    cursor: line.isDelete
                                                                                        ? "pointer"
                                                                                        : "not-allowed",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                                                        }`}
                                                                                ></i>
                                                                            </a>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Employee Attachment */}
                            <div
                                className="tab-pane fade show"
                                id="attachment"
                                role="tabpanel"
                                aria-labelledby="attachment-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">

                                                <div className="table-responsive poc-head rounded">
                                                    <table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "50%" }}>File Name</th>
                                                                <th style={{ width: "30%" }}>File Size</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData?.files.length != 0 ? formData?.files?.map((file, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {file.FileData ? (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={() => handleBlobDownload(file)}
                                                                            >
                                                                                Download {file.name}
                                                                            </button>
                                                                        ) : (
                                                                            <a
                                                                                href={
                                                                                    file.filePath
                                                                                        ? file.filePath
                                                                                        : URL.createObjectURL(file)
                                                                                }
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {file.name}
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {formData.filesize?.[index]}
                                                                    </td>
                                                                </tr>
                                                            )) : <tr>
                                                                <td className="text-center fw-bold " colSpan={2}>
                                                                    No Data Found
                                                                </td></tr>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="attach_msg">
                                                    Note:
                                                    <ul>
                                                        <li>
                                                            Please attach all relevant supporting documents.
                                                        </li>
                                                        <li>
                                                            File Naming Format: YourName_FileName.extension (e.g., JohnDoe_Resume.pdf, JohnDoe_10thMarkSheet.pdf).
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* qualification */}
                            <div
                                className="tab-pane fade show"
                                id="qualification"
                                role="tabpanel"
                                aria-labelledby="qualification-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">

                                                <div className="table-responsive poc-head rounded">
                                                    <table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "15%" }}>
                                                                    Qualification Type
                                                                    <span className="text-danger">*</span>
                                                                </th>
                                                                <th style={{ width: "10%" }}>
                                                                    Qualification
                                                                    <span className="text-danger">*</span>
                                                                </th>
                                                                <th style={{ width: "10%" }}>Stream</th>
                                                                <th style={{ width: "20%" }}>Institute</th>
                                                                <th style={{ width: "5%" }}>Percentage</th>
                                                                <th style={{ width: "15%" }}>
                                                                    Year Of Passing
                                                                </th>
                                                                <th style={{ width: "15%" }}>University</th>
                                                                <th style={{ width: "10%" }}>Del</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.qualification &&
                                                                formData.qualification.map &&
                                                                formData.qualification.map((line, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className="form-control"
                                                                                placeholder="Qualification Type"
                                                                                name="QualificationType"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .QualificationType
                                                                                }

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className={"form-control"}
                                                                                placeholder="Qualification"
                                                                                name="Qualification"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .Qualification
                                                                                }

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className="form-control"
                                                                                placeholder="Stream"
                                                                                name="Stream"
                                                                                value={
                                                                                    formData.qualification[index].Stream
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className="form-control"
                                                                                placeholder="Institute"
                                                                                name="Institute"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .Institute
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                type="number"
                                                                                className="form-control text-end"
                                                                                placeholder="%"
                                                                                name="Percentage"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .Percentage
                                                                                }

                                                                                onKeyDown={(e) => {
                                                                                    if (
                                                                                        ["e", "E", "+", "-", "."].includes(
                                                                                            e.key
                                                                                        )
                                                                                    ) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className="form-control text-end"
                                                                                placeholder="Year Of Passing"
                                                                                name="YearOfPassing"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .YearOfPassing
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className={
                                                                                    "form-control"
                                                                                }
                                                                                disabled
                                                                                placeholder="University"
                                                                                name="University"
                                                                                value={
                                                                                    formData.qualification[index]
                                                                                        .University
                                                                                }

                                                                            />
                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <a

                                                                                className={
                                                                                    line.isDelete
                                                                                        ? "text-danger"
                                                                                        : "text-muted"
                                                                                }
                                                                                style={{
                                                                                    pointerEvents: line.isDelete
                                                                                        ? "auto"
                                                                                        : "none",
                                                                                    cursor: line.isDelete
                                                                                        ? "pointer"
                                                                                        : "not-allowed",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                                                        }`}
                                                                                ></i>
                                                                            </a>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Employee identities */}
                            <div
                                className="tab-pane fade show"
                                id="identities"
                                role="tabpanel"
                                aria-labelledby="identities-tab"
                            >
                                <div className="container-fluid mt-2">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">

                                                <div className="table-responsive poc-head rounded">
                                                    <table
                                                        id="poctable_head"
                                                        className="table table-bordered"
                                                    >
                                                        <thead id="thcolor" className="text-center">
                                                            <tr>
                                                                <th style={{ width: "15%" }}>
                                                                    Identity Type
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "25%" }}>
                                                                    Name On Identity
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>
                                                                    Identity No.
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "15%" }}>
                                                                    Issuing Country
                                                                    <span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "13%" }}>
                                                                    Issue Date<span className="required">*</span>
                                                                </th>
                                                                <th style={{ width: "13%" }}>Expiry Date</th>
                                                                <th style={{ width: "4%" }}>Del</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.identities &&
                                                                formData.identities.map &&
                                                                formData.identities.map((line, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="IdentityType_063"
                                                                                value={identityTypeOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.identities[index]
                                                                                            .IdentityType_063
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...identityTypeOptions,
                                                                                ]}

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                disabled
                                                                                className={
                                                                                    "form-control"
                                                                                }
                                                                                placeholder="Name as per identity"
                                                                                name="NameOnIdentity"
                                                                                value={
                                                                                    formData.identities[index]
                                                                                        .NameOnIdentity
                                                                                }

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className={
                                                                                    "form-control"
                                                                                }
                                                                                placeholder="No"
                                                                                disabled
                                                                                name="IdentityNo"
                                                                                value={
                                                                                    formData.identities[index].IdentityNo
                                                                                }

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                isDisabled
                                                                                name="IssuingCountry"
                                                                                value={identityIssueingOptions.find(
                                                                                    (option) =>
                                                                                        option.value ===
                                                                                        formData.identities[index]
                                                                                            .IssuingCountry
                                                                                )}
                                                                                menuPortalTarget={document.body}
                                                                                styles={tableSelectStyle}
                                                                                menuPlacement="top"
                                                                                options={[
                                                                                    { value: "", label: "Select" },
                                                                                    ...identityIssueingOptions,
                                                                                ]}

                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <CustomDatePicker
                                                                                readOnly
                                                                                required={true}

                                                                                // index={index}
                                                                                module="identities"
                                                                                name="IssueDate"
                                                                                value={
                                                                                    formData.identities[index].IssueDate
                                                                                }
                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <CustomDatePicker
                                                                                readOnly
                                                                                required={true}

                                                                                // index={index}
                                                                                module="identities"
                                                                                name="ExpiryDate"
                                                                                value={
                                                                                    formData.identities[index].ExpiryDate
                                                                                }
                                                                            />
                                                                        </td>
                                                                        <td className="text-center align-middle">
                                                                            <a

                                                                                className={
                                                                                    line.isDelete
                                                                                        ? "text-danger"
                                                                                        : "text-muted"
                                                                                }
                                                                                style={{
                                                                                    pointerEvents: line.isDelete
                                                                                        ? "auto"
                                                                                        : "none",
                                                                                    cursor: line.isDelete
                                                                                        ? "pointer"
                                                                                        : "not-allowed",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                                                        }`}
                                                                                ></i>
                                                                            </a>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Additional identities */}
                            <div
                                className="tab-pane fade show"
                                id="additional"
                                role="tabpanel"
                                aria-labelledby="additional-tab"
                            >
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">Blood Group</label>
                                                <Select
                                                    isDisabled
                                                    name="BloodGroup_062"
                                                    options={[
                                                        { value: "", label: "Select" },
                                                        ...bloodGroupOptions,
                                                    ]}
                                                    // value={formData?.BloodGroup_062}
                                                    value={bloodGroupOptions.find(
                                                        (option) =>
                                                            option.value === formData?.BloodGroup_062
                                                    )}

                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">Maritial Status</label>
                                                <Select
                                                    isDisabled
                                                    name="MaritalStatus_021"
                                                    options={[
                                                        { value: "", label: "Select" },
                                                        ...maritialStatusOptions,
                                                    ]}
                                                    // value={formData?.MaritalStatus_021}
                                                    value={maritialStatusOptions.find(
                                                        (option) =>
                                                            option.value === formData?.MaritalStatus_021
                                                    )}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <label className="form-label">Nationality</label>
                                            <Select
                                                isDisabled
                                                options={[
                                                    { value: "", label: "Select" },
                                                    ...nationalityOptions,
                                                ]}
                                                // value={formData.Nationality}
                                                name="Nationality"
                                                value={nationalityOptions.find(
                                                    (option) => option.value === formData?.Nationality
                                                )}

                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">Anniversary Date</label>
                                                <CustomDatePicker
                                                    readOnly
                                                    name="DateOfAnniversary"
                                                    id="DateOfAnniversary"
                                                    placeholderText="DD-MMM-YYYY"
                                                    className="form-control"
                                                    value={formData?.DateOfAnniversary}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">
                                                    Appointment Date <span className="required">*</span>
                                                </label>
                                                <CustomDatePicker
                                                    readOnly
                                                    name="AppointmentDate"
                                                    id="AppointmentDate"
                                                    placeholderText="DD-MMM-YYYY"
                                                    value={formData?.AppointmentDate}

                                                    required={true}
                                                    className={`form-control ${errors?.AppointmentDate ? "is-invalid" : ""
                                                        }`}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">
                                                    Payroll Joining Date
                                                    <span className="required">*</span>
                                                </label>
                                                <CustomDatePicker
                                                    readOnly
                                                    name="PayrollJoiningDate"
                                                    id="PayrollJoiningDate"
                                                    placeholderText="DD-MMM-YYYY"

                                                    className="form-control"
                                                    value={formData?.PayrollJoiningDate}

                                                />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">
                                                    Joining Date<span className="required">*</span>
                                                </label>
                                                <CustomDatePicker
                                                    name="JoiningDate"
                                                    id="JoiningDate"
                                                    placeholderText="DD-MMM-YYYY"
                                                    value={formData?.JoiningDate}

                                                    maxDate={false}
                                                    readOnly
                                                    required={true}
                                                    className={`form-control ${errors?.JoiningDate ? "is-invalid" : ""
                                                        }`}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-2">
                                            <div className="">
                                                <label className="form-label">
                                                    Branch<span className="required">*</span>
                                                </label>
                                                <Select
                                                    isDisabled
                                                    options={[
                                                        { value: "", label: "Select" },
                                                        ...branchOptions,
                                                    ]}
                                                    name="BranchID"
                                                    value={branchOptions.find(
                                                        (option) => option.value === formData?.BranchID
                                                    )}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="mt-4">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        disabled
                                                        type="checkbox"
                                                        name="OnPayroll"
                                                        id="OnPayroll"
                                                        checked={formData?.OnPayroll === "1"}

                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="OnPayroll"
                                                    >
                                                        On Payroll
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="mt-4">
                                                <div className="form-check">
                                                    <input
                                                        disabled
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name="IsIntern"
                                                        id="IsIntern"
                                                        checked={formData?.IsIntern === "1"}

                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="IsIntern"
                                                    >
                                                        Apprenticeships
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="mt-4">
                                                <div className="form-check">
                                                    <input
                                                        disabled
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name="IsPartTime"
                                                        id="IsPartTime"
                                                        checked={formData?.IsPartTime === "1"}

                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="IsPartTime"
                                                    >
                                                        Part Time
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid d-flex justify-content-end mt-2">
                            <div>
                                <button
                                    type="reset"
                                    onClick={() => navigate(passedState?passedState:"/RMG/employees")}
                                    className="btn-info me-2"
                                >
                                    Back
                                </button>


                            </div>
                        </div>
                    </form>
                </div>
            </>
        );
    }

export default RMGEmployeeView;
